import { useState } from "react";
import {
  CheckCircle, AlertTriangle, X, Send,
  Clock, Zap, Users, ChevronLeft, ChevronRight, Bell,
  CalendarDays, ArrowRight
} from "lucide-react";

// ── Données simulées ─────────────────────────────────────────────────────────

const MA_PHARMACIE = "Pharmacie Centrale de Thiès";

const SEMAINES = [
  {
    debut: "2026-06-28", fin: "2026-07-05",
    pharmacies: [
      { nom: "Pharmacie Thiès Nord",   estMoi: false },
      { nom: "Pharmacie Mbour Centre", estMoi: false },
    ],
  },
  {
    debut: "2026-07-05", fin: "2026-07-12",
    pharmacies: [
      { nom: "Pharmacie Thiès Est",    estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
      { nom: "Pharmacie Mékhé",        estMoi: false },
      { nom: "Pharmacie Mboro",        estMoi: false },
    ],
  },
  {
    debut: "2026-07-12", fin: "2026-07-19",
    pharmacies: [
      { nom: "Pharmacie Thiès Ouest",  estMoi: false },
      { nom: "Pharmacie Mbour Nord",   estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
    ],
  },
  {
    debut: "2026-07-19", fin: "2026-07-26",
    statut: "en_attente",
    pharmacies: [
      { nom: MA_PHARMACIE,             estMoi: true  },
      { nom: "Pharmacie Mbour Sud",    estMoi: false },
    ],
  },
  {
    debut: "2026-07-26", fin: "2026-08-02",
    pharmacies: [
      { nom: "Pharmacie Thiès Nord",   estMoi: false },
      { nom: "Pharmacie Mékhé",        estMoi: false },
      { nom: "Pharmacie Mboro",        estMoi: false },
      { nom: "Pharmacie Ndiol",        estMoi: false },
      { nom: "Pharmacie Tassette",     estMoi: false },
      { nom: "Pharmacie Bargny",       estMoi: false },
    ],
  },
  {
    debut: "2026-08-02", fin: "2026-08-09",
    pharmacies: [
      { nom: "Pharmacie Thiès Est",    estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
    ],
  },
  {
    debut: "2026-08-09", fin: "2026-08-16",
    pharmacies: [
      { nom: "Pharmacie Mbour Centre", estMoi: false },
      { nom: "Pharmacie Thiès Ouest",  estMoi: false },
      { nom: "Pharmacie Mékhé",        estMoi: false },
    ],
  },
  {
    debut: "2026-08-16", fin: "2026-08-23",
    pharmacies: [
      { nom: "Pharmacie Mboro",        estMoi: false },
      { nom: "Pharmacie Mbour Nord",   estMoi: false },
    ],
  },
  {
    debut: "2026-08-23", fin: "2026-08-30",
    pharmacies: [
      { nom: "Pharmacie Thiès Nord",   estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
      { nom: "Pharmacie Ndiol",        estMoi: false },
    ],
  },
  {
    debut: "2026-08-30", fin: "2026-09-06",
    pharmacies: [
      { nom: "Pharmacie Thiès Est",    estMoi: false },
      { nom: "Pharmacie Mbour Centre", estMoi: false },
      { nom: "Pharmacie Bargny",       estMoi: false },
      { nom: "Pharmacie Tassette",     estMoi: false },
    ],
  },
  {
    debut: "2026-09-06", fin: "2026-09-13",
    pharmacies: [
      { nom: "Pharmacie Mékhé",        estMoi: false },
      { nom: "Pharmacie Thiès Ouest",  estMoi: false },
    ],
  },
  {
    debut: "2026-09-13", fin: "2026-09-20",
    pharmacies: [
      { nom: "Pharmacie Mboro",        estMoi: false },
      { nom: "Pharmacie Mbour Nord",   estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
    ],
  },
  {
    debut: "2026-09-20", fin: "2026-09-27",
    pharmacies: [
      { nom: "Pharmacie Thiès Nord",   estMoi: false },
      { nom: "Pharmacie Ndiol",        estMoi: false },
    ],
  },
  {
    debut: "2026-09-27", fin: "2026-10-04",
    pharmacies: [
      { nom: "Pharmacie Mbour Centre", estMoi: false },
      { nom: "Pharmacie Mékhé",        estMoi: false },
      { nom: "Pharmacie Tassette",     estMoi: false },
    ],
  },
  {
    debut: "2026-10-04", fin: "2026-10-11",
    statut: "a_venir",
    pharmacies: [
      { nom: MA_PHARMACIE,             estMoi: true  },
      { nom: "Pharmacie Thiès Est",    estMoi: false },
      { nom: "Pharmacie Tivaouane",    estMoi: false },
      { nom: "Pharmacie Mboro",        estMoi: false },
    ],
  },
];

const MOIS = [
  "Janvier","Février","Mars","Avril","Mai","Juin",
  "Juillet","Août","Septembre","Octobre","Novembre","Décembre"
];

// Couleur avatar déterministe basée sur le nom
const AVATAR_PALETTE = [
  "bg-violet-500","bg-blue-500","bg-sky-500","bg-teal-500",
  "bg-orange-500","bg-rose-500","bg-indigo-500","bg-cyan-600",
];
const avatarColor = nom => AVATAR_PALETTE[nom.length % AVATAR_PALETTE.length];
const initiales   = nom => {
  const mots = nom.replace(/^Pharmacie\s+/i, "").split(" ").filter(Boolean);
  return mots.slice(0, 2).map(m => m[0].toUpperCase()).join("");
};

// ── Utils dates ───────────────────────────────────────────────────────────────

const todayStr  = new Date().toISOString().split("T")[0];
const daysUntil = str => Math.ceil((new Date(str + "T12:00:00") - new Date()) / 86400000);

const fmtShort = str =>
  new Date(str + "T12:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
const fmtLong  = str =>
  new Date(str + "T12:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

const isEnCours  = s => s.debut <= todayStr && s.fin > todayStr;
const isFuture   = s => s.fin > todayStr;
const estMaGarde = s => s.pharmacies.some(p => p.estMoi);

// ── Page principale ───────────────────────────────────────────────────────────

export default function HorairesGarde() {
  const [tab, setTab]     = useState("mes");
  const [modal, setModal] = useState(null);
  const [motif, setMotif] = useState("");
  const [toast, setToast] = useState(null);

  const now = new Date();
  const [nav, setNav] = useState({ y: now.getFullYear(), m: now.getMonth() });
  const prevMois = () => setNav(v => v.m === 0  ? { y: v.y - 1, m: 11 } : { ...v, m: v.m - 1 });
  const nextMois = () => setNav(v => v.m === 11 ? { y: v.y + 1, m: 0  } : { ...v, m: v.m + 1 });

  const mesGardes   = SEMAINES.filter(estMaGarde);
  const maProchaine = mesGardes.find(s => isFuture(s));
  const enCours     = SEMAINES.find(isEnCours);

  const semainesMois = SEMAINES.filter(s => {
    const d = new Date(s.debut + "T12:00:00");
    return d.getFullYear() === nav.y && d.getMonth() === nav.m;
  });

  const alerteUrgente =
    maProchaine?.statut === "en_attente" && daysUntil(maProchaine.debut) <= 7
      ? maProchaine : null;

  const showToast = msg => { setToast(msg); setTimeout(() => setToast(null), 4500); };
  const confirmer = () => { setModal(null); showToast("Garde confirmée — le secrétariat a été notifié."); };
  const signaler  = () => {
    if (!motif.trim()) return;
    setModal(null); setMotif("");
    showToast("Empêchement signalé au secrétariat.");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 py-8">

        {/* ── Header ── */}
        <div className="mb-8">
          <h1 className="text-2xl font-extrabold text-gray-900 tracking-tight">Horaires & Garde</h1>
          <p className="text-sm text-gray-400 mt-1">Pharmacie Centrale de Thiès · Secteur Thiès</p>
        </div>

        {/* ── Toast succès ── */}
        {toast && (
          <div className="flex items-center gap-3 mb-6 px-5 py-3.5 bg-emerald-600 text-white rounded-xl shadow-lg text-sm font-semibold">
            <CheckCircle size={16} /> {toast}
          </div>
        )}

        {/* ── Alerte urgente ── */}
        {alerteUrgente && (
          <div className="flex items-center gap-4 mb-6 px-5 py-4 bg-amber-50 border border-amber-200 rounded-2xl shadow-sm">
            <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Bell size={18} className="text-amber-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-amber-900 text-sm">Confirmation requise</p>
              <p className="text-xs text-amber-700 mt-0.5">
                Garde du <strong>{fmtLong(alerteUrgente.debut)}</strong> — dans {daysUntil(alerteUrgente.debut)} jours
              </p>
            </div>
            <button
              onClick={() => setModal({ type: "confirm", semaine: alerteUrgente })}
              className="flex-shrink-0 px-4 py-2 bg-amber-600 text-white text-xs font-bold rounded-lg hover:bg-amber-700 transition-colors shadow-sm"
            >
              Confirmer
            </button>
          </div>
        )}

        {/* ── Tabs ── */}
        <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-xl p-1 mb-6 shadow-sm w-fit">
          {[
            { id: "mes",     label: "Mes Gardes",        count: mesGardes.filter(isFuture).length },
            { id: "secteur", label: "Planning du Secteur" },
          ].map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold transition-all ${
                tab === t.id
                  ? "bg-emerald-600 text-white shadow-sm"
                  : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              {t.label}
              {t.count > 0 && (
                <span className={`text-xs px-1.5 py-0.5 rounded-md font-bold ${
                  tab === t.id ? "bg-emerald-500 text-white" : "bg-gray-100 text-gray-600"
                }`}>
                  {t.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* ══ MES GARDES ══════════════════════════════════════════════════════ */}
        {tab === "mes" && (
          <div className="space-y-4">

            {/* Garde en cours si c'est moi */}
            {enCours && estMaGarde(enCours) && (
              <HeroCard
                semaine={enCours}
                enCours
                onConfirm={() => setModal({ type: "confirm", semaine: enCours })}
                onEmpechement={() => setModal({ type: "empechement", semaine: enCours })}
              />
            )}

            {/* Prochaine */}
            {maProchaine && !isEnCours(maProchaine) && (
              <HeroCard
                semaine={maProchaine}
                onConfirm={() => setModal({ type: "confirm", semaine: maProchaine })}
                onEmpechement={() => setModal({ type: "empechement", semaine: maProchaine })}
              />
            )}

            {/* Gardes ultérieures */}
            {mesGardes.filter(s => isFuture(s) && s !== maProchaine && !isEnCours(s)).length > 0 && (
              <div>
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3 mt-2">
                  Garde ultérieure
                </p>
                {mesGardes.filter(s => isFuture(s) && s !== maProchaine && !isEnCours(s)).map((s, i) => (
                  <MiniCard
                    key={i}
                    semaine={s}
                    onConfirm={() => setModal({ type: "confirm", semaine: s })}
                    onEmpechement={() => setModal({ type: "empechement", semaine: s })}
                  />
                ))}
              </div>
            )}

            {/* Vide */}
            {mesGardes.filter(isFuture).length === 0 && (
              <div className="py-20 text-center bg-white rounded-2xl border border-dashed border-gray-200">
                <CalendarDays size={36} className="text-gray-200 mx-auto mb-3" />
                <p className="font-semibold text-gray-400 text-sm">Aucune garde planifiée</p>
                <p className="text-xs text-gray-300 mt-1">
                  Le secteur n'a pas encore publié votre prochaine garde
                </p>
              </div>
            )}

            {/* Historique */}
            {mesGardes.filter(s => !isFuture(s)).length > 0 && (
              <div className="mt-6">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">
                  Historique
                </p>
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm divide-y divide-gray-100 overflow-hidden">
                  {mesGardes.filter(s => !isFuture(s)).map((s, i) => (
                    <div key={i} className="flex items-center justify-between px-5 py-3.5 hover:bg-gray-50 transition-colors">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                          <CalendarDays size={14} className="text-gray-400" />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-700">
                            {fmtShort(s.debut)} → {fmtShort(s.fin)}
                          </p>
                          <p className="text-xs text-gray-400">
                            {s.pharmacies.length} pharmacie{s.pharmacies.length > 1 ? "s" : ""} de garde
                          </p>
                        </div>
                      </div>
                      <span className="text-xs font-semibold text-gray-400 bg-gray-100 px-3 py-1 rounded-lg">
                        Réalisée
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ══ PLANNING DU SECTEUR ═════════════════════════════════════════════ */}
        {tab === "secteur" && (
          <div>
            {/* Nav mois */}
            <div className="flex items-center justify-between bg-white rounded-xl border border-gray-200 shadow-sm px-5 py-3.5 mb-5">
              <button
                onClick={prevMois}
                className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
              >
                <ChevronLeft size={15} /> Précédent
              </button>
              <div className="text-center">
                <p className="font-extrabold text-gray-900">{MOIS[nav.m]} {nav.y}</p>
                <p className="text-xs text-gray-400">
                  {semainesMois.length} semaine{semainesMois.length !== 1 ? "s" : ""} publiée{semainesMois.length !== 1 ? "s" : ""}
                </p>
              </div>
              <button
                onClick={nextMois}
                className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
              >
                Suivant <ChevronRight size={15} />
              </button>
            </div>

            {semainesMois.length === 0 ? (
              <div className="py-20 text-center bg-white rounded-2xl border border-dashed border-gray-200">
                <CalendarDays size={36} className="text-gray-200 mx-auto mb-3" />
                <p className="font-semibold text-gray-400 text-sm">
                  Aucune garde publiée pour {MOIS[nav.m]}
                </p>
              </div>
            ) : (
              <div className="space-y-2">
                {semainesMois.map((s, i) => (
                  <SecteurRow
                    key={i}
                    semaine={s}
                    onConfirm={() => setModal({ type: "confirm", semaine: s })}
                    onEmpechement={() => setModal({ type: "empechement", semaine: s })}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── Modal Confirmer ── */}
      {modal?.type === "confirm" && (
        <Modal title="Confirmer votre garde" onClose={() => setModal(null)}>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-5">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Semaine de garde</p>
            <p className="text-xl font-extrabold text-gray-900">
              {fmtLong(modal.semaine.debut)}
            </p>
            <p className="text-sm text-gray-500 mt-0.5">
              → {fmtLong(modal.semaine.fin)} à 21h00
            </p>
          </div>
          <div className="space-y-2 mb-6">
            <RuleItem icon={<Zap size={13} className="text-emerald-500" />} color="emerald">
              Ouverture continue 24h/24 pendant toute la semaine
            </RuleItem>
            <RuleItem icon={<Clock size={13} className="text-amber-500" />} color="amber">
              Fermeture samedi {fmtShort(modal.semaine.fin)} à 21h00 — relais semaine suivante
            </RuleItem>
          </div>
          <div className="flex gap-3">
            <button onClick={() => setModal(null)}
              className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl text-sm font-bold hover:bg-gray-200 transition-colors">
              Annuler
            </button>
            <button onClick={confirmer}
              className="flex-1 py-3 bg-emerald-600 text-white rounded-xl text-sm font-bold hover:bg-emerald-700 transition-colors shadow-sm flex items-center justify-center gap-2">
              <CheckCircle size={15} /> Je confirme
            </button>
          </div>
        </Modal>
      )}

      {/* ── Modal Empêchement ── */}
      {modal?.type === "empechement" && (
        <Modal title="Signaler un empêchement" onClose={() => setModal(null)}>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-5">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Garde concernée</p>
            <p className="text-xl font-extrabold text-gray-900">
              {fmtLong(modal.semaine.debut)}
            </p>
            <p className="text-sm text-gray-500 mt-0.5">→ {fmtLong(modal.semaine.fin)}</p>
          </div>
          <div className="mb-4">
            <label className="block text-xs font-bold text-gray-600 mb-2">
              Motif <span className="text-red-500">*</span>
            </label>
            <textarea
              value={motif}
              onChange={e => setMotif(e.target.value)}
              placeholder="Ex : Congé maladie, urgence familiale..."
              rows={3}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-200 focus:border-red-300 transition-all"
            />
          </div>
          <div className="flex items-start gap-3 p-3.5 bg-amber-50 border border-amber-100 rounded-xl mb-5">
            <AlertTriangle size={14} className="text-amber-500 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-amber-700 leading-relaxed">
              Signalez le plus tôt possible. Le secrétariat organisera un remplacement.
            </p>
          </div>
          <div className="flex gap-3">
            <button onClick={() => setModal(null)}
              className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl text-sm font-bold hover:bg-gray-200 transition-colors">
              Annuler
            </button>
            <button onClick={signaler} disabled={!motif.trim()}
              className="flex-1 py-3 bg-red-600 text-white rounded-xl text-sm font-bold hover:bg-red-700 transition-colors disabled:opacity-40 shadow-sm flex items-center justify-center gap-2">
              <Send size={14} /> Signaler
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Hero Card ─────────────────────────────────────────────────────────────────

function HeroCard({ semaine, enCours, onConfirm, onEmpechement }) {
  const [voirTout, setVoirTout] = useState(false);
  const jours = daysUntil(semaine.debut);
  const LIMIT = 4;
  const liste = voirTout ? semaine.pharmacies : semaine.pharmacies.slice(0, LIMIT);
  const reste = semaine.pharmacies.length - LIMIT;

  return (
    <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">
      {/* Top color bar */}
      <div className={`h-1.5 ${enCours
        ? "bg-gradient-to-r from-blue-500 to-cyan-400"
        : "bg-gradient-to-r from-emerald-500 to-teal-400"
      }`} />

      <div className="p-6">
        {/* Header */}
        <div className="flex items-start justify-between mb-5">
          <div>
            <div className="flex flex-wrap items-center gap-2 mb-2">
              {enCours ? (
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-blue-700 bg-blue-50 border border-blue-200 px-2.5 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                  GARDE EN COURS
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2.5 py-1 rounded-full">
                  PROCHAINE GARDE
                </span>
              )}
              {!enCours && semaine.statut === "en_attente" && (
                <span className="inline-flex items-center text-xs font-bold text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-full">
                  À CONFIRMER
                </span>
              )}
            </div>
            <h2 className="text-2xl font-extrabold text-gray-900 tracking-tight">
              {fmtShort(semaine.debut)}
              <span className="mx-2 font-light text-gray-300">→</span>
              {fmtShort(semaine.fin)}
            </h2>
          </div>

          {!enCours && (
            <div className="text-center bg-gray-50 border border-gray-200 rounded-2xl px-4 py-3 ml-4 flex-shrink-0">
              <p className="text-3xl font-black text-gray-900 leading-none">{jours}</p>
              <p className="text-xs text-gray-400 font-semibold mt-1">jours</p>
            </div>
          )}
        </div>

        {/* Pharmacies */}
        <div className="mb-5">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-1.5">
            <Users size={11} />
            {semaine.pharmacies.length} pharmacie{semaine.pharmacies.length > 1 ? "s" : ""} de garde
          </p>
          <div className="space-y-2">
            {liste.map((p, i) => (
              <div key={i} className={`flex items-center gap-3 p-3 rounded-xl border ${
                p.estMoi
                  ? "bg-emerald-50 border-emerald-100"
                  : "bg-gray-50 border-gray-100"
              }`}>
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-xs font-extrabold text-white flex-shrink-0 ${
                  p.estMoi ? "bg-emerald-600" : avatarColor(p.nom)
                }`}>
                  {initiales(p.nom)}
                </div>
                <span className={`text-sm flex-1 min-w-0 truncate ${
                  p.estMoi ? "font-bold text-emerald-800" : "font-medium text-gray-700"
                }`}>
                  {p.nom}
                </span>
                {p.estMoi && (
                  <span className="text-xs font-extrabold text-emerald-600 bg-emerald-100 border border-emerald-200 px-2 py-0.5 rounded-lg flex-shrink-0">
                    VOUS
                  </span>
                )}
              </div>
            ))}

            {!voirTout && reste > 0 && (
              <button
                onClick={() => setVoirTout(true)}
                className="w-full py-2.5 text-xs font-semibold text-gray-400 hover:text-gray-600 border border-dashed border-gray-200 rounded-xl hover:border-gray-300 hover:bg-gray-50 transition-all"
              >
                + {reste} autre{reste > 1 ? "s" : ""} pharmacie{reste > 1 ? "s" : ""}
              </button>
            )}
            {voirTout && semaine.pharmacies.length > LIMIT && (
              <button
                onClick={() => setVoirTout(false)}
                className="w-full py-2 text-xs font-semibold text-gray-400 hover:text-gray-600 transition-colors"
              >
                Réduire
              </button>
            )}
          </div>
        </div>

        {/* Règles */}
        <div className="grid grid-cols-2 gap-2 mb-5">
          <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-100 rounded-xl px-3.5 py-2.5">
            <Zap size={13} className="text-emerald-500 flex-shrink-0" />
            <span className="text-xs font-semibold text-emerald-800">Ouverture continue</span>
          </div>
          <div className="flex items-center gap-2 bg-amber-50 border border-amber-100 rounded-xl px-3.5 py-2.5">
            <Clock size={13} className="text-amber-500 flex-shrink-0" />
            <span className="text-xs font-semibold text-amber-800">
              Ferme sam. {fmtShort(semaine.fin)} 21h
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          {!enCours && semaine.statut === "en_attente" && (
            <button
              onClick={onConfirm}
              className="flex-1 flex items-center justify-center gap-2 py-3 bg-emerald-600 text-white font-bold rounded-xl text-sm hover:bg-emerald-700 transition-colors shadow-sm"
            >
              <CheckCircle size={15} /> Confirmer ma garde
            </button>
          )}
          <button
            onClick={onEmpechement}
            className={`flex items-center justify-center gap-2 py-3 border border-red-200 text-red-600 font-bold rounded-xl text-sm hover:bg-red-50 transition-colors ${
              enCours || semaine.statut !== "en_attente" ? "flex-1" : "px-5"
            }`}
          >
            <AlertTriangle size={14} />
            {enCours || semaine.statut !== "en_attente" ? "Signaler un empêchement" : "Empêchement"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Mini Card (gardes ultérieures) ───────────────────────────────────────────

function MiniCard({ semaine, onConfirm, onEmpechement }) {
  const jours = daysUntil(semaine.debut);
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center gap-4 px-5 py-4">
        <div className="w-12 h-12 bg-gray-50 border border-gray-200 rounded-xl flex flex-col items-center justify-center flex-shrink-0">
          <span className="text-lg font-black text-gray-700 leading-none">{jours}</span>
          <span className="text-[10px] text-gray-400 font-bold">jours</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-gray-900 text-sm">
            {fmtShort(semaine.debut)} → {fmtShort(semaine.fin)}
          </p>
          <div className="flex items-center gap-2 mt-1.5">
            <div className="flex -space-x-1.5">
              {semaine.pharmacies.slice(0, 5).map((p, i) => (
                <div key={i} className={`w-5 h-5 rounded-full border-2 border-white flex items-center justify-center text-[9px] font-black text-white flex-shrink-0 ${
                  p.estMoi ? "bg-emerald-600" : avatarColor(p.nom)
                }`}>
                  {initiales(p.nom)[0]}
                </div>
              ))}
              {semaine.pharmacies.length > 5 && (
                <div className="w-5 h-5 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center text-[9px] font-bold text-gray-600 flex-shrink-0">
                  +{semaine.pharmacies.length - 5}
                </div>
              )}
            </div>
            <span className="text-xs text-gray-400 font-medium">
              {semaine.pharmacies.length} pharmacie{semaine.pharmacies.length > 1 ? "s" : ""}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {semaine.statut === "en_attente" && (
            <button onClick={onConfirm}
              className="px-3.5 py-1.5 bg-emerald-600 text-white text-xs font-bold rounded-lg hover:bg-emerald-700 transition-colors shadow-sm">
              Confirmer
            </button>
          )}
          <button onClick={onEmpechement}
            className="p-2 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
            <AlertTriangle size={15} />
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Secteur Row ───────────────────────────────────────────────────────────────

function SecteurRow({ semaine, onConfirm, onEmpechement }) {
  const [voirTout, setVoirTout] = useState(false);
  const ec  = isEnCours(semaine);
  const moi = estMaGarde(semaine);
  const LIMIT = 3;
  const liste = voirTout ? semaine.pharmacies : semaine.pharmacies.slice(0, LIMIT);
  const reste = semaine.pharmacies.length - LIMIT;

  return (
    <div className={`bg-white rounded-xl border shadow-sm transition-shadow hover:shadow-md overflow-hidden ${
      ec  ? "border-l-4 border-l-blue-500   border-gray-200" :
      moi ? "border-l-4 border-l-emerald-500 border-gray-200" :
            "border-gray-200"
    }`}>
      <div className="flex items-start gap-4 px-5 py-4">

        {/* Dates */}
        <div className="w-32 flex-shrink-0">
          <p className={`text-sm font-extrabold ${moi || ec ? (ec ? "text-blue-800" : "text-emerald-800") : "text-gray-800"}`}>
            {fmtShort(semaine.debut)}
          </p>
          <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5 font-medium">
            <ArrowRight size={10} /> {fmtShort(semaine.fin)}
          </p>
        </div>

        {/* Pharmacies en pills */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            {liste.map((p, i) => (
              <span key={i} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold border ${
                p.estMoi
                  ? "bg-emerald-50 border-emerald-200 text-emerald-800"
                  : "bg-gray-50 border-gray-200 text-gray-700"
              }`}>
                <span className={`w-4 h-4 rounded-md flex items-center justify-center text-[9px] font-black text-white flex-shrink-0 ${
                  p.estMoi ? "bg-emerald-600" : avatarColor(p.nom)
                }`}>
                  {initiales(p.nom)[0]}
                </span>
                <span className={p.estMoi ? "font-extrabold" : ""}>{p.nom}</span>
                {p.estMoi && <span className="text-[9px] font-black text-emerald-600">▸ VOUS</span>}
              </span>
            ))}
            {!voirTout && reste > 0 && (
              <button
                onClick={() => setVoirTout(true)}
                className="text-xs font-semibold text-gray-400 hover:text-gray-700 hover:bg-gray-100 px-2 py-1 rounded-lg transition-colors"
              >
                + {reste} autre{reste > 1 ? "s" : ""}
              </button>
            )}
            {voirTout && semaine.pharmacies.length > LIMIT && (
              <button
                onClick={() => setVoirTout(false)}
                className="text-xs font-semibold text-gray-400 hover:text-gray-700 px-2 py-1 rounded-lg transition-colors"
              >
                Réduire
              </button>
            )}
          </div>
        </div>

        {/* Statut + actions */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {ec ? (
            <span className="text-xs font-bold text-blue-700 bg-blue-50 border border-blue-200 px-2.5 py-1 rounded-lg">
              En cours
            </span>
          ) : semaine.statut === "en_attente" ? (
            <span className="text-xs font-bold text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-lg">
              À confirmer
            </span>
          ) : isFuture(semaine) ? (
            <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-2.5 py-1 rounded-lg">
              Planifiée
            </span>
          ) : (
            <span className="text-xs text-gray-300 font-medium">Terminée</span>
          )}

          {moi && isFuture(semaine) && (
            <>
              {semaine.statut === "en_attente" && !ec && (
                <button onClick={onConfirm}
                  className="px-3 py-1.5 bg-emerald-600 text-white text-xs font-bold rounded-lg hover:bg-emerald-700 transition-colors shadow-sm">
                  Confirmer
                </button>
              )}
              <button onClick={onEmpechement}
                className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                <AlertTriangle size={13} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Modal wrapper ─────────────────────────────────────────────────────────────

function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-extrabold text-gray-900 text-base">{title}</h3>
          <button onClick={onClose}
            className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-xl transition-colors">
            <X size={16} className="text-gray-400" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ── Rule Item ─────────────────────────────────────────────────────────────────

function RuleItem({ icon, color, children }) {
  const cls = color === "emerald"
    ? "bg-emerald-50 border-emerald-100 text-emerald-800"
    : "bg-amber-50 border-amber-100 text-amber-800";
  return (
    <div className={`flex items-start gap-3 px-4 py-3 border rounded-xl text-xs font-medium ${cls}`}>
      <span className="flex-shrink-0 mt-0.5">{icon}</span>
      {children}
    </div>
  );
}
